// import React, { useState } from "react";
// import { useSearchParams } from "react-router-dom";
// // import { TabBar } from "./components/shared";
// import ComposeTab        from "./tabs/ComposeTab";
// import EmailTemplatesTab from "./tabs/EmailTemplatesTab";
// import EmailHistoryTab   from "./tabs/EmailHistoryTab";
// // import { TABS }          from "./constants";
// // import type { TabName }  from "./constants";
// import styles            from "../../../styles/mailCenter/mailCenter.module.scss";
// import tabBarStyles            from "../../../styles/mailCenter/shared.module.scss";


// interface TabBarProps {
//   tabs: typeof TABS;
//   active: TabName;
//   onChange: (tab: TabName) => void;
// }

//  const TABS = [
//   {
//     label: "Compose Email",
//     value: "compose-email",
//   },
//   {
//     label: "Email Templates",
//     value: "email-templates",
//   },
//   {
//     label: "Email History",
//     value: "email-history",
//   },
// ] as const;

//  type TabName = (typeof TABS)[number]["value"];

//  const TabBar: React.FC<TabBarProps> = ({ tabs, active, onChange }) => (
//   <div className={tabBarStyles["tab-bar"]}>
//     {tabs.map((tab) => (
//       <button
//         key={tab.value}
//         onClick={() => onChange(tab.value)}
//         className={[
//           tabBarStyles["tab-bar__item"],
//           active === tab.value ? tabBarStyles["tab-bar__item--active"] : "",
//         ].join(" ")}
//       >
//         {tab.label}
//       </button>
//     ))}
//   </div>
// );

// const MailCenter: React.FC = () => {
//   const [activeTab, setActiveTab] = useState<TabName>("compose-email");
// //   const [searchParams, setSearchParams] = useSearchParams();

// // const activeTab =
// //   (searchParams.get("tab") as TabName) || "compose-email";

// // const setActiveTab = (tab: TabName) => {
// //   setSearchParams({ tab });
// // };

//   return (
//     <div className={styles["mail-center"]}>
//       <div className={styles["mail-center__inner"]}>
//         <h1 className={styles["mail-center__heading"]}>Mail Center</h1>

//         <TabBar tabs={TABS} active={activeTab} onChange={setActiveTab} />

//         {activeTab === "compose-email"   && <ComposeTab />}
//         {activeTab === "email-templates" && <EmailTemplatesTab />}
//         {activeTab === "email-history"   && <EmailHistoryTab />}
//       </div>
//     </div>
//   );
// };

// export default MailCenter;



import React, { useState } from "react";

import ComposeTab from "./tabs/ComposeTab";
import EmailTemplatesTab from "./tabs/EmailTemplatesTab";
import EmailHistoryTab from "./tabs/EmailHistoryTab";

import styles from "../../../styles/mailCenter/mailCenter.module.scss";
import tabBarStyles from "../../../styles/mailCenter/shared.module.scss";

const TABS = [
  {
    label: "Compose Email",
    value: "compose-email",
  },
  {
    label: "Email Templates",
    value: "email-templates",
  },
  {
    label: "Email History",
    value: "email-history",
  },
] as const;

type TabName = (typeof TABS)[number]["value"];

interface TabBarProps {
  tabs: typeof TABS;
  active: TabName;
  onChange: (tab: TabName) => void;
}

const TabBar: React.FC<TabBarProps> = ({
  tabs,
  active,
  onChange,
}) => (
  <div className={tabBarStyles["tab-bar"]}>
    {tabs.map((tab) => (
      <button
        key={tab.value}
        onClick={() => onChange(tab.value)}
        className={[
          tabBarStyles["tab-bar__item"],
          active === tab.value
            ? tabBarStyles["tab-bar__item--active"]
            : "",
        ].join(" ")}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

const MailCenter: React.FC = () => {
  const [activeTab, setActiveTab] =
    useState<TabName>("compose-email");

  return (
    <div className={styles["mail-center"]}>
      <div className={styles["mail-center__inner"]}>
        <h1 className={styles["mail-center__heading"]}>
          Mail Center
        </h1>

        <TabBar
          tabs={TABS}
          active={activeTab}
          onChange={setActiveTab}
        />

        {activeTab === "compose-email" && <ComposeTab />}
        {activeTab === "email-templates" && <EmailTemplatesTab />}
        {activeTab === "email-history" && <EmailHistoryTab />}
      </div>
    </div>
  );
};

export default MailCenter;